import useStore, { updateScreenWidth } from '../Store/Store';

import AppleIcon from '@mui/icons-material/Apple';
import FacebookIcon from '@mui/icons-material/Facebook';
import MicrosoftIcon from '@mui/icons-material/Microsoft';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import GoogleIcon from '../images/google.png';
import {
  Box,
  Checkbox,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  Link,
  TextField,
  Typography,
} from '@mui/material';
import React from 'react';
import Logo from '../images/logo.png';
import SideImage from '../images/loginImage.svg';
import { resendOtpApi, signupApi, updateUserInfo, updateUserType, verifyOtpApi } from '../utils/api';
import { useMutation } from 'react-query';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { auth, provider, signInWithPopup, signCustomToken } from '../utils/firebase';
import { isEmpty, kebabCase } from 'lodash';
import DoneIcon from '@mui/icons-material/Done';
import Otp from './SignupOnboardingSteps/Otp';
import { toast } from 'react-toastify';
import UserType from './SignupOnboardingSteps/UserType';
import UserForm from './SignupOnboardingSteps/UserForm';
import InviteCareTeam from './SignupOnboardingSteps/InviteCareTeam';
import InviteCareRecipients from './SignupOnboardingSteps/InviteCareRecipients';
import validator from '../input-validation.service';
import { careUserType } from '../constants';
import DeviceIntegration from './SignupOnboardingSteps/DeviceIntegration';
import Button from '../components/Button';
import SocialLoginButton from '../components/SocialLoginButton';
import userService from '../user.service';
import { OAuthProvider } from 'firebase/auth';
import LanguageSelector from '../components/LanguageSelector';
import { useTranslation } from 'react-i18next';
const SignUp = () => {
  const history = useNavigate();
  const user = useStore((state) => state.user);
  const width = useStore((state) => state.screenWidth);
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const { t } = useTranslation();
  const [state, setState] = React.useState({
    email: '',
    password: '',
    userType: '',
    termsAgree: false,
    errorMessage: '',
    showPassword: false,
  });
  const [passwordChecker, setPasswordChecker] = React.useState({
    length: false,
    number: false,
    special: false,
  });
  const [inviteCGLoader, setInviteCGLoader] = React.useState(false);

  React.useEffect(() => {
    if (!isEmpty(sessionStorage.getItem('userType'))) {
      setState((prev) => {
        return { ...prev, userType: sessionStorage.getItem('userType') };
      });
    }
  }, []);

  const [step, setStep] = React.useState(-1);

  const updateDimensions = () => {
    updateScreenWidth(window.innerWidth);
  };
  React.useEffect(() => {
    window.addEventListener('resize', updateDimensions);
    return () => window.removeEventListener('resize', updateDimensions);
  }, []);

  React.useEffect(() => {
    if (!isEmpty(query.get('step'))) {
      setStep(parseInt(query.get('step')));
    } else {
      setStep(-1);
    }
  }, [query]);

  const signUpHandler = useMutation(signupApi, {
    onSuccess: async ({ data }) => {
      sessionStorage.setItem('email', state.email);
      sessionStorage.setItem('token', data?.token);
      sessionStorage.setItem('userId', data?.userId);
      history('/sign-up?step=0');
      setStep(0);
    },
    onError: (error) => {
      console.log('error =====> ', error);
      setState((prev) => {
        return { ...prev, errorMessage: error?.response?.data?.message || 'Something went wrong!' };
      });
    },
  });

  const resendOtpHandler = useMutation(resendOtpApi, {
    onSuccess: async ({ data }) => {
      toast(t('otpHasBeenSent'));
    },
    onError: (error) => {
      console.log('error =====> ', error);
      setState((prev) => {
        return { ...prev, errorMessage: error?.response?.data?.message || 'Something went wrong!' };
      });
    },
  });

  const verifyOtpHandler = useMutation(verifyOtpApi, {
    onSuccess: async ({ data }) => {
      history('/sign-up?step=1');
      setStep(1);
    },
    onError: (error) => {
      console.log('error =====> ', error);
      setState((prev) => {
        return { ...prev, errorMessage: error?.response?.data?.message || 'Something went wrong!' };
      });
    },
  });

  const updateUserTypeHandler = useMutation(updateUserType, {
    onSuccess: async ({ data }) => {
      sessionStorage.setItem('userType', state.userType);
      history('/sign-up?step=2');
      setStep(2);
    },
    onError: (error) => {
      console.log('error =====> ', error);
      setState((prev) => {
        return { ...prev, errorMessage: error?.response?.data?.message || 'Something went wrong!' };
      });
    },
  });

  const updateUserInfoHandler = useMutation(updateUserInfo, {
    onSuccess: async ({ data }) => {
      if (state.userType === careUserType.professional_caregiver) {
        history('/login');
        sessionStorage.clear();
        return 0;
      } else {
        history('/sign-up?step=3');
        setStep(3);
      }
    },
    onError: (error) => {
      console.log('error =====> ', error);
      if (error?.response?.status === 400) {
        return setState((prev) => {
          return { ...prev, errorMessage: error?.response?.data?.data?.join(',') || 'Something went wrong!' };
        });
      } else {
        return setState((prev) => {
          return { ...prev, errorMessage: error?.response?.data?.message || 'Something went wrong!' };
        });
      }
    },
  });

  const signup = async () => {
    if (!state.email || !state.password) {
      return setState((prev) => {
        return { ...prev, errorMessage: 'Email and Password are required fields' };
      });
    }

    const { length, number, special } = passwordChecker;
    if (!length || !number || !special) {
      return setState((prev) => {
        return { ...prev, errorMessage: 'Password not matched with policy!' };
      });
    }

    if (!state.termsAgree) {
      return setState((prev) => {
        return { ...prev, errorMessage: 'Must agree with the terms and policy' };
      });
    }

    setState((prev) => {
      return { ...prev, errorMessage: '' };
    });

    signUpHandler.mutate({ email: state.email, password: state.password });
  };
  const handleAppleSignin = async () => {
    try {
      const provider = new OAuthProvider('apple.com');
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      const idToken = await user.getIdToken();
      const { data } = await axios.post(
        process.env.REACT_APP_EXPRESS_URL + `/api/canCare/socialSignin`,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            authorization: idToken,
          },
        },
      );
      const loginData = data?.data || null;
      console.log('🍎 SignUp Apple Login Response:', loginData);

      if (loginData?.user) {
        userService.updateAuthData({
          accessToken: loginData.token,
          currentUserId: loginData.userId,
          rememberMe: state.rememberMe,
        });
        userService.updateStorage({
          accessToken: loginData.token,
          currentUserId: loginData.userId,
          rememberMe: state.rememberMe,
        });
        useStore.getState().updateUser(loginData?.user);
        userService.updateCurrentUser(loginData.user);
        localStorage.setItem('auth', loginData.token + '~29#215@rfeqwEt0');

        // Save refresh token if available
        if (loginData.refreshToken) {
          localStorage.setItem('refreshToken', loginData.refreshToken);
          sessionStorage.setItem('refreshToken', loginData.refreshToken);
          console.log('✅ SignUp Apple: Refresh token saved');
        } else {
          console.log('⚠️ SignUp Apple: No refresh token in response');
        }

        sessionStorage.setItem('fromLogin', 'true');

        // Sign in with Firebase custom token if available
        if (loginData.firebaseCustomToken) {
          try {
            const response = await signCustomToken(loginData.firebaseCustomToken);
            if (response?.user?.uid) {
              console.log('✅ SignUp Apple: Firebase sign-in successful, UID:', response.user.uid);
            }
          } catch (error) {
            console.error('⚠️ SignUp Apple: Firebase sign-in error:', error);
          }
        } else {
          console.log('⚠️ SignUp Apple: No Firebase token provided');
        }

        if (!loginData.user.careUserType) {
          history('/sign-up?step=1');
        } else {
          history('/main');
        }
      }
    } catch (error) {
      console.error('Error signing in with Apple:', error);
      setState((prev) => {
        return { ...prev, errorMessage: error?.response?.data?.message || 'Something went wrong!' };
      });
    }
  };
  const handleGoogleSignIn = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      const idToken = await user.getIdToken();

      const { data } = await axios.post(
        process.env.REACT_APP_EXPRESS_URL + `/api/canCare/socialSignin`,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            authorization: idToken,
          },
        },
      );
      const loginData = data?.data || null;
      console.log('🔍 SignUp Google Login Response:', loginData);

      if (loginData?.user) {
        userService.updateAuthData({
          accessToken: loginData.token,
          currentUserId: loginData.userId,
          rememberMe: state.rememberMe,
        });

        userService.updateStorage({
          accessToken: loginData.token,
          currentUserId: loginData.userId,
          rememberMe: state.rememberMe,
        });

        useStore.getState().updateUser(loginData?.user);
        userService.updateCurrentUser(loginData.user);
        localStorage.setItem('auth', loginData.token + '~29#215@rfeqwEt0');

        // Save refresh token if available
        if (loginData.refreshToken) {
          localStorage.setItem('refreshToken', loginData.refreshToken);
          sessionStorage.setItem('refreshToken', loginData.refreshToken);
          console.log('✅ SignUp Google: Refresh token saved');
        } else {
          console.log('⚠️ SignUp Google: No refresh token in response');
        }

        sessionStorage.setItem('fromLogin', 'true');

        // Sign in with Firebase custom token if available
        if (loginData.firebaseCustomToken) {
          try {
            const response = await signCustomToken(loginData.firebaseCustomToken);
            if (response?.user?.uid) {
              console.log('✅ SignUp Google: Firebase sign-in successful, UID:', response.user.uid);
            }
          } catch (error) {
            console.error('⚠️ SignUp Google: Firebase sign-in error:', error);
          }
        } else {
          console.log('⚠️ SignUp Google: No Firebase token provided');
        }

        if (!loginData.user.careUserType) {
          history('/sign-up?step=1');
        } else {
          history('/main');
        }
      }
    } catch (error) {
      console.error('Error signing in with Google:', error);
    }
  };

  React.useEffect(() => {
    if (!isEmpty(user)) {
      history('/main');
    }
  }, [user]);

  const handleSetPassword = (event) => {
    const { value } = event.target;

    if (value.length > 8) {
      setPasswordChecker((prev) => {
        return { ...prev, length: true };
      });
    } else {
      setPasswordChecker((prev) => {
        return { ...prev, length: false };
      });
    }
    if (/[0-9]/.test(value)) {
      setPasswordChecker((prev) => {
        return { ...prev, number: true };
      });
    } else {
      setPasswordChecker((prev) => {
        return { ...prev, number: false };
      });
    }
    if (/[^a-zA-Z0-9]/.test(value)) {
      setPasswordChecker((prev) => {
        return { ...prev, special: true };
      });
    } else {
      setPasswordChecker((prev) => {
        return { ...prev, special: false };
      });
    }

    setState((prev) => {
      return { ...prev, password: event.target.value };
    });
  };

  const handleClickTerms = () => {
    window.open('https://can.co/pages/terms-of-use');
  };
  const handleClickPolicy = () => {
    window.open('https://can.co/pages/privacy-policy');
  };

  const handleSubmitOtp = (otp) => {
    let processOtp = otp.join('');

    if (processOtp.length !== 6) {
      return setState((prev) => {
        return { ...prev, errorMessage: 'Incomplete otp entered!' };
      });
    }

    setState((prev) => {
      return { ...prev, errorMessage: '' };
    });
    let email = state.email || sessionStorage.getItem('email');
    verifyOtpHandler.mutate({ email, otp: processOtp });
  };

  const handleResendOtp = (email) => {
    resendOtpHandler.mutate({ email });
  };

  const handleNextStep = () => {
    if (step === 3 && state.userType === careUserType.cargiver) {
      history('/login');
      sessionStorage.clear();
      return 0;
    } else if (step === 4 && state.userType === careUserType.careRecipient) {
      history('/login');
      sessionStorage.clear();
      return 0;
    }
    history(`/sign-up?step=${step + 1}`);
  };

  const handleBackStep = () => {
    history(`/sign-up?step=${step - 1}`);
  };

  const handleUpdateUserType = () => {
    if (isEmpty(state.userType)) {
      return setState((prev) => {
        return { ...prev, errorMessage: 'User type cannot be empty!' };
      });
    }

    updateUserTypeHandler.mutate({ userType: state.userType });
  };

  const handleSubmitUserInfo = (userData) => {
    const { firstName, lastName, dob, phoneNo, image } = userData;
    if (isEmpty(firstName)) {
      return setState((prev) => {
        return { ...prev, errorMessage: 'First Name cannot be empty' };
      });
    }
    if (isEmpty(lastName)) {
      return setState((prev) => {
        return { ...prev, errorMessage: 'Last Name cannot be empty' };
      });
    }
    if (isEmpty(dob)) {
      return setState((prev) => {
        return { ...prev, errorMessage: 'Birth date cannot be empty' };
      });
    }
    if (isEmpty(phoneNo) || !validator.validatePhoneNumber(phoneNo)) {
      return setState((prev) => {
        return { ...prev, errorMessage: 'Phone is not valid' };
      });
    }

    setState((prev) => {
      return { ...prev, errorMessage: '' };
    });

    const body = {
      firstName,
      lastName,
      dob,
      phoneNo,
      imageUrl: image,
    };

    updateUserInfoHandler.mutate({ body });
  };

  const handleInviteCaregivers = async (emails) => {
    try {
      setInviteCGLoader(true);
      let promises = [];

      emails.forEach((item) => {
        promises.push(
          axios.post(
            process.env.REACT_APP_EXPRESS_URL + `/api/canCare/user/${sessionStorage.getItem('userId')}/inviteCaregiver`,
            {
              email: item?.email || '',
              phoneNo: item?.phoneNo || '',
              relation: item?.relation || '',
            },
            {
              headers: {
                'Content-Type': 'application/json',
                authorization: sessionStorage.getItem('token'),
              },
            },
          ),
        );
      });

      await Promise.all(promises);
      history(`/sign-up?step=${step + 1}`);
    } catch (e) {
      console.log('e =====> ', e);
    } finally {
      setInviteCGLoader(false);
    }
  };

  const handleSkipStep = () => {
    history(`/sign-up?step=${step + 1}`);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        width: '100vw',
        height: '100vh',
        backgroundColor: 'white',
      }}
    >
      {step === -1 && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: width > 1050 ? '50%' : '100%',
            padding: '1rem',
            position: 'relative',
          }}
        >
          {/* Language Selector positioned in top-right */}
          <Box
            sx={{
              position: 'absolute',
              top: '1rem',
              right: '1rem',
              zIndex: 10,
            }}
          >
            <LanguageSelector variant="button" />
          </Box>

          <Box
            component="img"
            sx={{ width: '55px', height: '37.56px', marginBottom: '2rem' }}
            alt="Mask group"
            src={Logo}
          />
          <div style={{ paddingInline: '4rem', paddingBlock: '10rem' }}>
            <Typography variant="h4" gutterBottom mb={6}>
              {t('signUp')}
            </Typography>
            <Grid container spacing={2} sx={{ marginBottom: '1rem', justifyContent: 'center' }}>
              <Grid item xs={3}>
                <SocialLoginButton
                  text={t('apple')}
                  icon={<AppleIcon />}
                  onClick={handleAppleSignin}
                  sx={{ fontSize: width > 1420 ? '14px' : '11px' }}
                />
              </Grid>
              <Grid item xs={3}>
                <SocialLoginButton
                  text={t('google')}
                  icon={<img src={GoogleIcon} style={{ width: '20px', height: '20px' }} alt="Google" />}
                  onClick={handleGoogleSignIn}
                  sx={{ fontSize: width > 1420 ? '14px' : '11px' }}
                />
              </Grid>
              {/* <Grid item xs={3}>
                <Button
                  variant="outlined"
                  startIcon={width > 1420 ? <MicrosoftIcon /> : null}
                  fullWidth
                  sx={{
                    borderRadius: '50px',
                    color: 'black',
                    border: '1px solid lightgrey',
                    fontSize: width > 1420 ? '14px' : '11px',
                  }}
                >
                  {width < 1420 ? <MicrosoftIcon /> : 'Microsoft'}
                </Button>
              </Grid>
              <Grid item xs={3}>
                <Button
                  variant="outlined"
                  startIcon={width > 1420 ? <FacebookIcon /> : null}
                  fullWidth
                  sx={{
                    borderRadius: '50px',
                    color: 'black',
                    border: '1px solid lightgrey',
                    fontSize: width > 1420 ? '14px' : '11px',
                  }}
                >
                  {width < 1420 ? <FacebookIcon /> : 'Facebook'}
                </Button>
              </Grid> */}
            </Grid>

            <Divider sx={{ marginY: '1rem', color: 'grey' }}>or</Divider>

            <TextField
              label={t('email')}
              variant="outlined"
              fullWidth
              sx={{ marginBottom: '1rem', borderRadius: '50px' }}
              InputProps={{
                style: { borderRadius: '50px' },
              }}
              onChange={(event) =>
                setState((prev) => {
                  return { ...prev, email: event.target.value };
                })
              }
            />

            <TextField
              label={t('password')}
              variant="outlined"
              fullWidth
              type={state.showPassword ? 'text' : 'password'}
              sx={{ marginBottom: '1rem', borderRadius: '50px' }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      edge="end"
                      onClick={() =>
                        setState((prev) => {
                          return { ...prev, showPassword: !state.showPassword };
                        })
                      }
                    >
                      {!state.showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                    </IconButton>
                  </InputAdornment>
                ),
                style: { borderRadius: '50px' },
              }}
              onChange={handleSetPassword}
            />

            <div style={{ display: 'flex', fontSize: '13px', marginBottom: '20px' }}>
              <div style={{ display: 'flex', color: passwordChecker.length ? '#01796b' : 'grey' }}>
                <DoneIcon style={{ fontSize: '17px', marginRight: '5px' }} /> Min 8 characters
              </div>
              <div
                style={{ display: 'flex', marginInline: '20px', color: passwordChecker.number ? '#01796b' : 'grey' }}
              >
                <DoneIcon style={{ fontSize: '17px', marginRight: '5px' }} /> 1 number
              </div>
              <div style={{ display: 'flex', color: passwordChecker.special ? '#01796b' : 'grey' }}>
                <DoneIcon style={{ fontSize: '17px', marginRight: '5px' }} /> 1 special character
              </div>
            </div>

            <div style={{ marginBlock: '20px' }}>
              <FormControlLabel
                control={
                  <Checkbox
                    onClick={() =>
                      setState((prev) => {
                        return { ...prev, termsAgree: !prev.termsAgree };
                      })
                    }
                    value={state.termsAgree}
                  />
                }
              />
              <span style={{ fontSize: '14px', marginLeft: '-15px' }}>
                {t('agreeTermsPolicy')}{' '}
                <span style={{ fontWeight: '500', color: '#01796b', cursor: 'pointer' }} onClick={handleClickTerms}>
                  {t('terms')}
                </span>
                ,{' '}
                <span style={{ fontWeight: '500', color: '#01796b', cursor: 'pointer' }} onClick={handleClickPolicy}>
                  {t('privacyPolicy')}
                </span>
              </span>
            </div>

            <Button fullWidth text={t('createAccount')} loading={signUpHandler.isLoading} onClick={signup} />

            <Typography component="h1" variant="subtitle1" style={{ color: 'red' }} textAlign="center" my={1}>
              {state.errorMessage}
            </Typography>

            <Typography variant="body2">
              {t('alreadyHaveAccount')}
              <Link
                variant="body2"
                style={{ color: '#01796b', textDecoration: 'none', cursor: 'pointer' }}
                href="/#/login"
              >
                {t('logIn')}
              </Link>
            </Typography>
          </div>
        </Box>
      )}
      {step === 0 && (
        <Otp
          email={state.email}
          handleSubmitOtp={handleSubmitOtp}
          handleResendOtp={handleResendOtp}
          loader={verifyOtpHandler.isLoading}
          errorMessage={state.errorMessage}
        />
      )}
      {step === 1 && (
        <UserType
          userType={state.userType}
          setUserType={(type) =>
            setState((prev) => {
              return { ...prev, userType: type };
            })
          }
          handleNextStep={handleUpdateUserType}
          errorMessage={state.errorMessage}
          loader={updateUserTypeHandler.isLoading}
        />
      )}
      {step === 2 && (
        <UserForm
          handleBackStep={handleBackStep}
          handleNextStep={handleSubmitUserInfo}
          email={state.email}
          errorMessage={state.errorMessage}
          loader={updateUserInfoHandler.isLoading}
          userType={state.userType}
        />
      )}

      {state.userType === careUserType.cargiver && (
        <>{step === 3 && <InviteCareRecipients handleBackStep={handleBackStep} handleNextStep={handleNextStep} />}</>
      )}

      {state.userType === careUserType.careRecipient && (
        <>
          {step === 3 && (
            <InviteCareTeam
              handleBackStep={handleBackStep}
              handleNextStep={handleInviteCaregivers}
              handleSkipStep={handleSkipStep}
              loader={inviteCGLoader}
            />
          )}
          {step === 4 && <DeviceIntegration handleBackStep={handleBackStep} handleNextStep={handleNextStep} />}
        </>
      )}

      {width > 1050 && (
        <Box
          component="img"
          sx={{
            width: '50%',
            height: '97%',
            objectFit: 'cover',
            padding: '1rem',
            borderRadius: '30px',
          }}
          alt="Rectangle"
          src={SideImage}
        />
      )}
    </Box>
  );
};

export default SignUp;
